import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const styles = makeStyles(({ spacing }) => ({
  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "calc(100vh - 64px)",
    paddingBottom: spacing(3),
  },
  bottomLogoRow: {
    justifyContent: "center",
    marginBottom: spacing(5),
  },
  copyrightClaim: {
    color: grey[500],
    fontSize: "14px",
  },
  root: {
    padding: spacing(3),
    borderRadius: spacing(1.5),
    border: `1px solid ${grey["300"]}`,
    margin: "auto",
    maxWidth: "min-content",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: spacing(3),
    backgroundColor: "white",
  },
  header: {
    fontWeight: 500,
    lineHeight: 1,
  },
  headerText: {
    fontSize: 14,
  },
}));
export default styles;
